<template>
  <div class="pdf-wrapper">
    <iframe
      :src="`/view/index/template/src/assets/js/pdfjs/web/viewer.html?file=${url}`"
      frameborder="0"
      class="pdf-window"
    >
    </iframe>
  </div>
</template>

<style lang="less" scoped>
  .pdf-wrapper{
    width: 100%;
    min-height: 100vh;
    .pdf-window{
      width: 100%;
      min-height: 100vh;
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        url: this.$route.query.url || '',
      }
    },
    mounted() {
      // PDFJS.getDocument(this.url).then((pdf) => {
      //   return pdf.getPage(1);
      // }).then((page) => {
      //   // 设置展示比例
      //   var scale = 1.5;
      //   // 获取pdf尺寸
      //   var viewport = page.getViewport(scale);
      //   // 获取需要渲染的元素
      //   var canvas = document.getElementById('pdf-canvas');
      //   var context = canvas.getContext('2d');
      //   canvas.height = viewport.height;
      //   canvas.width = viewport.width;

      //   var renderContext = {
      //       canvasContext: context,
      //       viewport: viewport
      //   };

      //   page.render(renderContext);
      // });
    },
    created() {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/scriptPdf.vue